<template src="./PostQualificationNotFound.html"></template>

<script>
import { defineComponent } from "vue";

export default defineComponent({});
</script>

<style></style>
